import { render, staticRenderFns } from "./staff_list.vue?vue&type=template&id=27e93ed8&scoped=true&"
import script from "./staff_list.vue?vue&type=script&lang=ts&"
export * from "./staff_list.vue?vue&type=script&lang=ts&"
import style0 from "./staff_list.vue?vue&type=style&index=0&id=27e93ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e93ed8",
  null
  
)

export default component.exports